<!-- Loader -->
<div *ngIf="!isLoaded" class="flex h-[360px] w-full flex-col items-center justify-center gap-4">
  <div class="h-9 w-9 animate-spin rounded-full border-4 border-gray-300 border-t-gray-800"></div>
  <span class="text-sm font-medium text-gray-400">
    Impressions
  </span>
</div>

<!-- Chart Content -->
<div *ngIf="isLoaded" class="w-full">

  <!-- Header -->
  <div class="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
    <h2 class="text-lg font-semibold tracking-tight text-gray-900">
      Impressions
    </h2>

    <ng-container *ngIf="metricValue !== null && metricValue > 0">
      <div class="text-left sm:text-right">
        <p class="text-2xl font-bold text-gray-900">
          {{ metricValue | number }}
        </p>

        <p
          class="mt-1 flex items-center gap-1 text-sm font-medium sm:justify-end"
          [ngClass]="{
            'text-green-600': metricDiff > 0,
            'text-red-500': metricDiff < 0,
            'text-gray-500': metricDiff === 0
          }"
        >
          <span *ngIf="metricDiff > 0" class="text-base">↑</span>
          <span *ngIf="metricDiff < 0" class="text-base">↓</span>
          <span *ngIf="metricDiff === 0" class="text-gray-400">–</span>

          {{ metricDiff > 0 ? '' + (metricDiff | number) : (metricDiff | number) }}
          <span class="text-gray-400">vs. start</span>
        </p>
      </div>
    </ng-container>
  </div>

  <!-- Content -->
  <div class="relative grid grid-cols-12">

    <ng-container *ngIf="metricValue !== null && metricValue > 0; else noData">

      <!-- Chart -->
      <div class="col-span-12">
        <apx-chart
          #chartRef
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [xaxis]="chartOptions.xaxis"
          [yaxis]="chartOptions.yaxis"
          [stroke]="chartOptions.stroke"
          [colors]="chartOptions.colors"
          [dataLabels]="chartOptions.dataLabels"
          class="h-[360px] w-full block"
        >
        </apx-chart>
      </div>

    </ng-container>

    <!-- No Data -->
    <ng-template #noData>
      <div class="col-span-12 flex h-[360px] w-full items-center justify-center rounded-2xl bg-gray-50">
        <img
          src="assets/images/charts-not-found.png"
          alt="No data available"
          class="h-full w-full object-contain opacity-80 select-none"
        />
      </div>
    </ng-template>

  </div>

</div>